import React from "react";

export default function AdditionalInfo() {
  return <div>AdditionalInfo</div>;
}
